import { FC } from "react";
import { IOverviewSectionProps } from "..";

export const DataSync: FC<IOverviewSectionProps<HTMLDivElement>> = ({ forwardRef }) => {
  return <></>;
};
